import { render, staticRenderFns } from "./LinkContainer.vue?vue&type=template&id=49169156"
import script from "./LinkContainer.vue?vue&type=script&lang=js"
export * from "./LinkContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports